import React, { useState, useContext } from "react";
import {
  combineValidators,
  composeValidators,
  isRequired,
  matchesField,
  hasLengthLessThan,
} from "revalidate";
import { RootStoreContext } from "../../app/stores/rootStore";
import { IUserResetPassword } from "../../app/models/user";
import { toast } from "react-toastify";
import {
  Segment,
  Form,
  Header,
  Checkbox,
  Button,
  Grid,
} from "semantic-ui-react";
import { Form as FinalForm, Field } from "react-final-form";
import TextInput from "../../app/common/form/TextInput";
import { useParams } from "react-router-dom";

document.title = "Establecer contraseña";

const validate = combineValidators({
  NewPassword: composeValidators(
    isRequired({ message: "La contraseña nueva es obligatoria" }),
    hasLengthLessThan(65)({
      message: "La contraseña debe tener máximo 64 caracteres",
    })
  )(),
  NewPasswordConfirm: composeValidators(
    isRequired({ message: "Éste campo es obligatorio" }),
    matchesField(
      "NewPassword",
      ""
    )({
      message: "Debe coincidir con la contraseña nueva",
    })
  )(),
});


const ResetPasswordForm: React.FC = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { resetPassword } = rootStore.userStore;
  const { loading } = rootStore.buttonLoadingStore;

  const { resetToken } = useParams();


  //variables para mostrar la contraseña
  const [shown, setShown] = useState(false);
  const switchShown = () => setShown(!shown);

  //variables para el uso del checkbox
  const [validaciones] = useState({
    v1: false,
    v2: false,
    v3: false,
    v4: false,
  });

  //expreciones regulares a validar
  const regex1 = /.{8,}/;
  const regex2 = /[a-z]+/;
  const regex3 = /[A-Z]+/;
  const regex4 = /^(?=.*\d)|(\W)/;

  const [resetPasswordData] = useState<IUserResetPassword>({
    NewPassword: "",
    NewPasswordConfirm: "",
  });

  const handleFinalFormSubmit = (values: any) => {
    if (
      validaciones.v1 &&
      validaciones.v2 &&
      validaciones.v3 &&
      validaciones.v4
    ) {
      resetPassword(values, resetToken);
    } else {
      toast.error("Requisitos incompletos para establecer tu clave");
    }
  };

  const validacionCheck = (value: any) => {
    if (value.target.name === "NewPassword") {
      let str = value.target.value;

      //validacion min 8 caracteres
      if (regex1.test(str)) validaciones.v1 = true;
      else validaciones.v1 = false;

      //validacion 1 carácter min
      if (regex2.test(str)) validaciones.v2 = true;
      else validaciones.v2 = false;

      //validacion 1 carácter may
      if (regex3.test(str)) validaciones.v3 = true;
      else validaciones.v3 = false;

      //validacion
      if (regex4.test(str)) validaciones.v4 = true;
      else validaciones.v4 = false;
    }
  };

  return (
    <div style={{ margin: "8%", marginLeft: "25%", marginRight: "25%" }}>
      <Segment clearing padded="very">
        <FinalForm
          validate={validate}
          initialValues={resetPasswordData}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit }) => (
            <Form onSubmit={handleSubmit} onChange={validacionCheck}>
              <Header as="h2" textAlign="center">
                <h4>Establecer contraseña</h4>
              </Header>
              <Grid>
                <Grid.Column floated="left" width={8}>
                  <label>Contraseña nueva</label>
                </Grid.Column>
                <Grid.Column floated="right" width={6}>
                  <a
                    href="#"
                    className="password__button"
                    onClick={switchShown}
                  >
                    {shown ? "Ocultar contraseña" : "Mostrar contraseña"}
                  </a>
                </Grid.Column>
              </Grid>
              <Field
                name="NewPassword"
                value={resetPasswordData.NewPassword}
                type={shown ? "text" : "password"}
                component={TextInput}
              />
              <label>Cofirma tu contraseña</label>
              <Field
                name="NewPasswordConfirm"
                id="NewPasswordConfirm"
                type="password"
                placeholder="Contraseña"
                value={resetPasswordData.NewPasswordConfirm}
                component={TextInput}
              />
              <label>Requisitos para la contraseña:</label>
              <div className="passwordRequirements">
                <br />
                <Form.Field>
                  <Checkbox
                    label="Al menos 8 caracteres de longitud"
                    checked={validaciones.v1 ? true : false}
                    readOnly
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    label="Un carácter en minúscula"
                    checked={validaciones.v2 ? true : false}
                    readOnly
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    label="Un carácter en mayúscula"
                    checked={validaciones.v3 ? true : false}
                    readOnly
                  />
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    label="Un número, símbolo o espacio en blanco"
                    checked={validaciones.v4 ? true : false}
                    readOnly
                  />
                </Form.Field>
              </div>
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Form>
          )}
        />
      </Segment>
    </div>
  );
};

export default ResetPasswordForm;
